import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import './NotificationCard.css';

const NotificationCard = ({ item, onClick }) => {
    const getIcon = () => {
        switch (item.notificationType) {
            case 'ORDER_PLACED':
                return faShoppingCart;
            default:
                return faBell;
        }
    };

    return (
        <div 
            className={`notification-card-item ${!item.isRead ? 'unread' : ''}`} 
            onClick={() => onClick(item)}
        >
            <div className="notification-icon-container">
                {!item.isRead && <div className="unread-dot" />}
                <FontAwesomeIcon 
                    icon={getIcon()} 
                    className={`notification-icon ${!item.isRead ? 'active' : ''}`} 
                />
            </div>
            <div className="notification-content">
                <div className="notification-title">{item.title}</div>
                <div className="notification-body">{item.body}</div>
                <div className="notification-time">{moment(item.createdDate).fromNow()}</div>
            </div>
        </div>
    );
};

export default NotificationCard;
